import type React from "react";

/**
 * Loading skeleton for {@link OverviewChart}. Mirrors the chart shell (toolbar row +
 * plot body) with shimmer bars. Reuses the global `skeleton-shimmer-bar` class
 * (honors `prefers-reduced-motion`) and the staggered `--shimmer-delay` from the
 * competitor chart skeleton. Presentational only — `role="status"` + `aria-busy`.
 */
export function OverviewChartSkeleton() {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Loading overview chart"
      data-testid="overview-chart-skeleton"
      className="rounded-[14px] border border-border bg-card p-[21px]"
    >
      {/* Header: title bar + view-mode toggle placeholder. */}
      <div className="flex items-center justify-between gap-4">
        <div className="skeleton-shimmer-bar h-4 w-48 rounded-md" />
        <div
          className="skeleton-shimmer-bar h-8 w-44 rounded-full"
          style={{ "--shimmer-delay": "120ms" } as React.CSSProperties}
        />
      </div>

      {/* Metric pills row. */}
      <div
        className="skeleton-shimmer-bar mt-3 h-[37px] w-64 rounded-[10px]"
        style={{ "--shimmer-delay": "180ms" } as React.CSSProperties}
      />

      {/* Plot body — matches the live chart's `h-[428px]` track. */}
      <div
        className="skeleton-shimmer-bar mt-4 h-[428px] w-full rounded-md"
        style={{ "--shimmer-delay": "300ms" } as React.CSSProperties}
      />
    </div>
  );
}
